import { useState, useRef } from "react";

export default function UploadModal({ vendorName, onUpload, onCancel }) {
  const [file, setFile] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef();

  const handleFile = (f) => {
    if (f && f.type === "application/pdf") setFile(f);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    handleFile(e.dataTransfer.files[0]);
  };

  const handleSubmit = async () => {
    if (!file) return;
    setUploading(true);
    try {
      await onUpload(file);
      onCancel();
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>Upload purchase order</h3>
        <p>Adding to <strong>{vendorName}</strong></p>

        <div
          className={`drop-zone${dragOver ? " drag-over" : ""}`}
          onClick={() => inputRef.current.click()}
          onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
          onDragLeave={() => setDragOver(false)}
          onDrop={handleDrop}
        >
          <input
            ref={inputRef}
            type="file"
            accept="application/pdf"
            style={{ display: "none" }}
            onChange={(e) => handleFile(e.target.files[0])}
          />
          {file ? (
            <>
              <i className="ti ti-file-type-pdf" style={{ color: "#C94B2A" }} aria-hidden="true" />
              <p>{file.name}</p>
              <span>{(file.size / 1024).toFixed(0)} KB</span>
            </>
          ) : (
            <>
              <i className="ti ti-upload" aria-hidden="true" />
              <p>Drop a PDF here or click to browse</p>
              <span>PDF files only</span>
            </>
          )}
        </div>

        <div className="modal-actions" style={{ marginTop: 16 }}>
          <button className="btn" onClick={onCancel} disabled={uploading}>Cancel</button>
          <button
            className="btn btn-primary"
            disabled={!file || uploading}
            onClick={handleSubmit}
          >
            {uploading ? "Uploading…" : "Upload"}
          </button>
        </div>
      </div>
    </div>
  );
}
